import React from 'react';
import ReactPaginate from 'react-paginate';

interface ContactPaginationProps {
  page: number;
  pageCount: number;
  total: number;
  onPageChange: (selected: number) => void;
  isLoading: boolean;
  totalLabel: string;
  summaryText?: string;
}

export const ContactPagination: React.FC<ContactPaginationProps> = ({
  page,
  pageCount,
  total,
  onPageChange,
  isLoading,
  totalLabel,
  summaryText,
}) => {
  return (
    <div className='pagination-container d-flex flex-column flex-sm-row justify-content-between align-items-center mt-4'>
      <div className="d-flex align-items-center gap-3 text-muted">
        {summaryText && <span>{summaryText}</span>}
      </div>

      <div className="pagination-wrapper">
        <ReactPaginate
          previousLabel='<'
          nextLabel='>'
          pageCount={pageCount}
          forcePage={page - 1}
          onPageChange={(e) => onPageChange(e.selected)}
          containerClassName={'pagiantion'}
          previousLinkClassName={'pagination__link'}
          nextLinkClassName={'pagination__link'}
          disabledClassName={'pagination__link--disabled'}
          activeClassName={'pagination__link--active'}
          disableInitialCallback={true}
          disabledLinkClassName={isLoading ? 'disabled' : ''}
          pageRangeDisplayed={window.innerWidth < 576 ? 1 : 2}
          marginPagesDisplayed={window.innerWidth < 576 ? 1 : 2}
        />
      </div>
    </div>
  );
};
